<template>
  <div class="Assignment">
    <p class="line">
        <b></b>欠款金额
    </p>
    <ul>
        <li style="margin-right: 20%;">
            <span>欠款金额</span>
            <el-input v-model="money1" placeholder="请输入欠款金额(元)" class="input"></el-input>
        </li>
    </ul>
    <p class="line" style="padding-top:3%">
        <b></b>悬赏金额(催收成功后，债权人支付一定的佣金)
    </p>
    <ul>
        <li style="margin-right: 20%;">
            <span>悬赏金额</span>
            <el-input v-model="money2" placeholder="请输入悬赏金额(元)" class="input" v-on:input="tips()"></el-input>
            <span class="tip" v-show="tip_show" style="display: block;width: 100%;color: red;font-size: 12px;margin-top: 5px;">举报人获得赏金({{tip}})元</span>
        </li>
    </ul>
    <p class="line" style="padding-top:3%">
        <b></b>悬赏任务及说明   
    </p>
    <ul>
        <el-input
            type="textarea"
            :autosize="{ minRows: 3 }"
            placeholder="请您具体说明悬赏任务"
            v-model="textareaValue"  style="margin-top: 40px;">
        </el-input>
        <b class="tag" @click="addtxt('帮我找到人')">帮我找到人</b>
        <b class="tag" @click="addtxt('推进案件进程')">推进案件进程</b>
        <b class="tag" @click="addtxt('找到债务人,隐匿资产')">找到债务人,隐匿资产</b>
        <b class="tag" @click="addtxt('协助讨回欠款')">协助讨回欠款</b>
        <b class="tag" @click="addtxt('代理诉讼')">代理诉讼</b>
        <b class="tag" @click="addtxt('代理执行')">代理执行</b>
    </ul>
    <p class="line" style="padding-top:3%">
        <b></b>债权难度：
        <el-rate v-model="xx" style="display: inline-block;height: 18px;margin-left: 1rem;"></el-rate>  
    </p>
    <p class="line" style="padding-top:3%">
        <b></b>允许转让：
        <el-switch
        v-model="zr"
        active-color="#13ce66"
        inactive-color="#c3c3c3">
        </el-switch>        
    </p>



    <div class="check">
        <button @click="back()">上一步</button>
        <button class="active" @click="nextone()">下一步</button>
    </div>

  </div>
</template>

<script>
export default {
  props:{

  },
  data () {
    return {
        money1:'',
        money2:'',
        textareaValue:'',
        xx:0,
        tip:'',
        tip_show:false,
        zr:false
    }
  },
  components:{

  },
  mounted(){
      // 从本地获取缓存数据
      if(window.sessionStorage.getItem('Assignment3')){
          var info = JSON.parse(window.sessionStorage.getItem('Assignment3'));
          this.money1 = info.money1;
          this.money2 = info.money2;
          this.textareaValue = info.textareaValue;
          this.xx = info.xx;
          this.zr = info.zr;
        }
  },
  methods: {
    tips(){
        if(isNaN(this.money2) == false){
            this.tip_show = true;
            this.tip = (this.money2*0.6).toFixed(2);
        }else{
            this.tip_show = false;
        }
        if(!this.money2.length){
            this.tip_show = false;
        }
    }, 
    addtxt(txt){
        if(this.textareaValue.length == 0){
            this.textareaValue += txt;
        }else{
            this.textareaValue += ' '+txt;
        }
    },
    nextone(){
        if(this.money1 == ''){
            this.$message.error('请填写欠款金额');
            return
        }else if(this.money2 == ''){
            this.$message.error('请填写悬赏金额');
            return
        }else if(isNaN(this.money1) == true || isNaN(this.money2) == true){
            this.$message.error('请填写正确的欠款金额');
            return
        }else if(this.textareaValue == ''){
            this.$message.error('请填写悬赏任务及说明');
            return
        }else if(this.xx == 0){
            this.$message.error('请选择债权难度');
            return
        }
        // 数据缓存本地
        var obj = new Object();
        obj.money1 = this.money1;
        obj.money2 = this.money2;
        obj.textareaValue = this.textareaValue;
        obj.xx = this.xx;
        obj.zr = this.zr;
        var a = JSON.stringify(obj);
        window.sessionStorage.setItem('Assignment3',a); 


        // ***跳转
        // this.$emit('son','4')
        // return;
        // --------------------------
        let param = new URLSearchParams();
        var _this = this;
        param.append("flag", '3');
        param.append("debt_money", this.money1*100);
        param.append("re_commissionratio", this.money2*100);
        param.append("debt_otherdes", this.textareaValue);
        param.append("re_creditordifficulty", this.xx);
        param.append("orderid",window.sessionStorage.getItem('orderid'));
        param.append('is_transfer',this.zr?1:0);
        this.$http.post(api.Assignment,param).then(function(res){
            if(res.data.code == 100001){
                window.sessionStorage.setItem('orderid',res.data.data.orderid);
                _this.$emit('son','4')
            }else{
                _this.$message.error(res.data.message);
            }
        })

    },
    back(){
        this.$emit('son','2')
    }
  }   
}



</script>

<style scoped >

.Assignment{
    background:#FFFFFF;
    padding: 3% 3%;
}
.Assignment .line{
    color: #2fb8c2;
    font-weight: bold;
}
.Assignment .line b{
    display: inline-block;
    width: 5px;
    background: #2fb8c2;
    height: 20px;
    vertical-align: bottom;
    margin-right: 1rem;
    border-radius: 10px;
}
.Assignment ul{
    overflow:hidden;
}
.Assignment ul li{
    float:left;
    box-sizing: border-box;
    width:40%;
    margin-top: 10px;
    padding: 30px 0;
    border-bottom: 1px solid #d3d3d3;
    height: 100px;
    
}
.Assignment ul li span{
    display: inline-block;
    width: 21%;
    text-align:left;
}
.Assignment ul li>label{
    text-align:center;
    width:35%
    
}
.select{
    text-align: right;
}
.select span{
    float:left;
    line-height:40px;
}
.check{
    padding-top: 3%;
    text-align:center;
}
.check button{
    border: none;
    outline: none;
    padding: 20px 50px;
    border-radius: 10px;
    background: #FFFFFF;
    border: 1px solid #d3d3d3;
    margin: 0 50px;
    cursor: pointer;
}
.check button:hover{
    background:#2fb8c2;
    color:#ffffff;
}
.check button.active{
    background:#2fb8c2;
    color:#ffffff;
}
.input{
    width:75%
}
.tag{
    float: left;
    font-size: 12px;
    padding: 5px;
    border: 1px solid #f0f0f0;
    margin: 5px 5px 5px 0;
    cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/common/Assignment3.vue